<script lang="ts">
    import PlusIcon from "../../Icons/plus.svg";
    import { Button, Label, TextField } from "attractions";
    import Product from "../../Models/Product";
    import { setLatestAddedProduct } from "../../Stores/Product";
    import { toasts } from "svelte-toasts";

    let name: string;
    let price: string;
    let discount: string;

    async function sendAddPurchaseRequest() {
        if (name && price && discount) {
            const res = await Product.add(name, discount, price);
            name = '';
            price = '';
            discount = '';
            setLatestAddedProduct(res._id);
        } else {
            toasts.error(`Uwaga`, `Sprawdź pola formularza i spróbuj ponownie.`);
        }
    }
</script>

<section class="addNewProduct">
    <header>
        <Label>Dodaj nowy produkt</Label>
    </header>
    <TextField bind:value={name} placeholder="Nazwa produktu" style="max-width: 450px" />
    <section class="additionalFields">
        <section class="discountPercentage">
            <TextField bind:value={discount} withItem type="number" min="0" max="100" placeholder="Zniżka">
                <span class="item">%</span>
            </TextField>
        </section>
        <section class="basePrice">
            <TextField bind:value={price} withItem type="number" min="0" placeholder="Cena">
                <span class="item">zł</span>
            </TextField>
        </section>
        <Button on:click={sendAddPurchaseRequest} round neutral><span class="icon">{@html PlusIcon}</span></Button>
    </section>
</section>

<style lang="scss">
    .addNewProduct {
        header {
            margin-bottom: .5rem;
        }

        .additionalFields {
            display: flex;

            .basePrice,
            .discountPercentage {
                width: 120px;
                margin-right: .5rem;
            }

            .icon {
                width: 20px;
                height: 20px;
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }
    }
</style>